require('rc-slider/assets/index.css');
require('./RANetworthPercentageSlider.scss');
require('./RANetworthPercentageSlider.override.scss');

// @vendors
const React = require('react');
const Slider = require('rc-slider').default;
const PropTypes = require('prop-types');

const coin = require('../../assets/icons/coin.svg');
const arrow = require('../../assets/icons/dropdown_down.svg');

const blueColor = '#002b45';
const buildLabelStyles = () => ({
    width: 300,
    textAlign: 'left',
    marginLeft: 10,
    color: blueColor,
    fontSize: 14,
});

const MIN_VALUE = 1;
const MAX_VALUE = 4;

class RANetworthPercentageSlider extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {
        if (value < MIN_VALUE || value > MAX_VALUE) {
            return;
        }

        this.props.changeSelectedOption(value);
    }

    getMarks() {
        const { value, steps } = this.props;
        const marks = steps.reduce((acc, step) => {
            acc[step.id] = { label: step.label, style: buildLabelStyles() };
            if (step.id == value) {
                acc[value].style.fontWeight = 'bold';
            }
            return acc;
        }, {});

        return marks;
    }

    buildCoinArrow() {
        const { value } = this.props;
        const top = `${-5 + value}px`;
        return (
            <img
                className="ra-networth-percentage-slider__arrow"
                src={arrow}
                style={{ top }}
            />
        );
    }

    buildCoins() {
        const { value } = this.props;
        const coins = [];
        for (let i = 0; i < 10; i++) {
            const modifier = i < value * 2 ? 'enabled' : 'disabled';
            const arrowIcon =
                i + 1 === value * 2 ? this.buildCoinArrow() : null;

            coins.push(
                <div className="ra-networth-percentage-slider__coin">
                    <img
                        className={`ra-networth-percentage-slider__coin-image ra-networth-percentage-slider__coin-image--${modifier}`}
                        key={i}
                        src={coin}
                    />
                    {arrowIcon}
                </div>,
            );
        }
        return coins.reverse();
    }

    render() {
        const {
            value,
            titleText,
            subtitleText,
            disabled,
            titleTooltip,
        } = this.props;
        const marks = this.getMarks();
        const coins = this.buildCoins();

        return (
            <div className="ra-networth-percentage-slider">
                <div className="ra-networth-percentage-slider__head">
                    <div className="ra-networth-percentage-slider__title">
                        <h2>
                            {titleText} {titleTooltip}
                        </h2>
                    </div>
                    <div className="ra-networth-percentage-slider__subtitle">
                        {subtitleText}
                    </div>
                </div>

                <div className="ra-networth-percentage-slider__container">
                    <div className="ra-networth-percentage-slider__left">
                        {coins}
                    </div>
                    <div className="ra-networth-percentage-slider__right">
                        <Slider
                            className="ra-networth-percentage-slider__rc-slider"
                            vertical
                            min={MIN_VALUE - 1}
                            max={MAX_VALUE + 1}
                            marks={marks}
                            value={value}
                            onChange={this.handleChange}
                            tipFormatter={null}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RANetworthPercentageSlider.propTypes = {
    changeSelectedOption: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    steps: PropTypes.array,
    titleText: PropTypes.string.isRequired,
    subtitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.number.isRequired,
    titleTooltip: PropTypes.any,
};

module.exports = RANetworthPercentageSlider;
